module.exports = __webpack_public_path__ + "assets/dash-alt.1ed3cb10.svg";